import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { App } from "@capacitor/app";
import { Keyboard } from "@capacitor/keyboard";

let inited = false;

// Inizializza l'esperienza "app": status bar, chiusura splash, tastiera, back-button Android.
// No-op sul web. Da chiamare una sola volta all'avvio.
export async function initAppShell() {
  if (!Capacitor.isNativePlatform() || inited) return;
  inited = true;

  try {
    await StatusBar.setStyle({ style: Style.Dark }); // testo chiaro su sfondo scuro
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#0A0A0C" });
    }
  } catch (e) {}

  try { await SplashScreen.hide({ fadeOutDuration: 300 }); } catch (e) {}

  try { if (Keyboard.setResizeMode) await Keyboard.setResizeMode({ mode: "native" }); } catch (e) {}

  // Back button hardware Android: torna indietro, oppure esce se sei sulla Home.
  try {
    App.addListener("backButton", ({ canGoBack }) => {
      const path = window.location.pathname;
      const atRoot = path === "/home" || path === "/" || path === "/esplora";
      if (canGoBack && window.history.length > 1 && !atRoot) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch (e) {}
}
